// extracted by mini-css-extract-plugin
export default {"adr":"AdrTemplate_adr__Tr1d6"};